import type { RutaProd } from '../../../../runtime/rutas';
export default {
  ruta: '/sistema/reportesbi/Dashboard/Compositivo',
  documento: 'reportesbi',
  acceso: 'sesion',
  filas: ['117'],
  cita: 'Areas/ReportesBI/Controllers/DashboardController.cs:420',
} satisfies RutaProd;
